import { lightTheme } from '../../styles/theme';

import { SyncStatus } from '../../types';

export const renderMenuSyncStatusColor = (s: SyncStatus | string) => {
  switch (s) {
    case SyncStatus.Completed:
      return lightTheme.green;
    case SyncStatus.Failed:
      return lightTheme.primary;
    case SyncStatus.InProgress:
      return lightTheme.yellow;
    case SyncStatus.Waiting:
      return lightTheme.yellow;
    case SyncStatus.Pending:
      return lightTheme.primary;
  }
};

export const renderMenuSyncStatusName = (s: SyncStatus | string) => {
  switch (s) {
    case SyncStatus.Completed:
      return 'Published';
    case SyncStatus.Failed:
      return 'Failed';
    case SyncStatus.InProgress:
      return 'Publishing';
    case SyncStatus.Waiting:
      return 'Waiting for provider connection';
    case SyncStatus.Pending:
      return 'Not Published';
  }
};
